import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  secondHeader: {
    padding: "16px 20px 0px 20px",
    [theme.breakpoints.down("md")]: {
      paddingTop: 0,
    },
  },
  firstFilterRow: {
    display: "inline-flex",
    alignItems: "center",
    width: "100%",
    marginTop: 18,
    height: 56,
  },
  inventoryContainer: {
    paddingBottom: "32px",
    margin: "0 32px",
    [theme.breakpoints.down("md")]: {
      margin: "0 16px",
    },
  },
  listingsContainer: {
    width: "calc(100vw - 64px)",
    margin: "28px 0 65px 0",
    [theme.breakpoints.up("sm")]: {
      minHeight: "50vh",
    },
    [theme.breakpoints.down("md")]: {
      width: "calc(100vw - 32px)",
      margin: "0 0 40px 0",
      minHeight: 200,
    },
  },
  filterCountBadge: {
    marginRight: 4,
    marginLeft: 8,
  },
  desktopOnly: {
    display: "hidden",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  showMoreContainer: {
    width: 184,
    textAlign: "-webkit-center",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: 16,
    marginBottom: 64,
  },
  noResults: {
    margin: "100px auto",
    textAlign: "center",
    padding: "0 30px",
  },
  loadingSpinner: {
    textAlign: "center",
    position: "relative",
    top: "min(10vh, 65px)",
    margin: "auto",
  },
  radiusModalSaveButton: {
    borderRadius: 300,
  },
  letsChatButtonContainer: {
    textAlign: "center",
    marginTop: 32,
    marginBottom: 32,
  },
  letsChatButton: {
    minWidth: 184,
  },
  noResultsButtonsContainer: {
    marginTop: 16,
    gap: 16,
    display: "flex",
    justifyContent: "center",
  },
  customBlackBadge: {
    backgroundColor: "black",
    color: "white",
  },
}));
